import React from "react";

import styles from "./LoadingFallback.module.css";

function SkeletonAvatar() {
	return <div className={styles.skeletonAvatar} />;
}

function SkeletonText({ width }: { width: string }) {
	return <div className={styles.skeletonText} style={{ width }} />;
}

function SkeletonAssigneeGroup() {
	return (
		<section className={styles.assigneeGroup}>
			<div className={styles.assigneeContainer}>
				<SkeletonAvatar />
				<SkeletonText width="40%" />
			</div>
			<div className={styles.actionItemsList}>
				{Array.from({ length: 3 }).map((_, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<div key={index} className={styles.skeletonActionItem}>
						<div className={styles.skeletonCheckbox} />
						<div className={styles.skeletonActionItemContent}>
							<SkeletonText width={index === 0 ? "80%" : index === 1 ? "100%" : "90%"} />
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export function LoadingFallback() {
	return (
		<div className={styles.container} role="status" aria-busy="true">
			{Array.from({ length: 2 }).map((_, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<SkeletonAssigneeGroup key={index} />
			))}
		</div>
	);
}
